<div class="maintenance-mode-container" (click)="onOverlayClick($event)">

  <div class="inner">

      <div class="maintenance-content">
        <div class="maintenance-icon">
          <img src="/assets/icons/maintenance-mode.svg" alt="maintenance-mode">
        </div>
        <div class="title">
          <span>{{translations.title}}</span>
        </div>
        <div class="description">
          <div>{{translations.description}}</div>
        </div>
        <div class="contact">
          <div class="mail">{{translations.mailText}} <a href="mailto:usersupport@finstral.com">usersupport&#64;finstral.com</a></div>
          <div class="epilogue">{{translations.epilogueFirst}}</div>
          <div class="epilogue">{{translations.epilogueLast}}</div>
        </div>
      </div>
    </div>

</div>
